import { useEffect as c, useContext as a, createContext as f } from "react";
function m(n, e, i = {}) {
  const { disabled: t = !1 } = i;
  c(() => {
    if (t)
      return;
    const s = (o) => {
      o.key === n && (o.preventDefault(), e());
    };
    return document.addEventListener("keydown", s), () => {
      document.removeEventListener("keydown", s);
    };
  }, [n, e, t]);
}
const l = f(!1);
function v() {
  return a(l);
}
function y(n, e, i = {}) {
  const { disabled: t = !1, enableEscKey: s = !0 } = i;
  m("Escape", e, { disabled: t || !s }), c(() => {
    if (t)
      return;
    const o = (r) => {
      const u = r.target;
      n.some(
        (d) => d.current?.contains(u)
      ) || (r.stopPropagation(), e());
    };
    return document.addEventListener("click", o), () => {
      document.removeEventListener("click", o);
    };
  }, [e, n, t, s]);
}
export {
  l as E,
  m as a,
  y as b,
  v as u
};
//# sourceMappingURL=useClickOutside-726e7c36.mjs.map
